/**
 * The path this build is served under: "/" on its own domain, "/my/" when the
 * coach worker serves it at coach.brandsmeetcreators.com/my/ (VITE_BASE_PATH,
 * see vite.config.ts). Router links already get it from BrowserRouter's
 * basename; these helpers are for everything the router does not see: URLs
 * handed to Supabase / TikTok to come back to, and files in public/.
 */
export const BASE_PATH: string = import.meta.env.BASE_URL || "/";

/** BrowserRouter basename: "/my" for a sub-path build, undefined at the root. */
export const ROUTER_BASENAME: string | undefined = BASE_PATH === "/" ? undefined : BASE_PATH.replace(/\/+$/, "");

/** "/logo.png" → "/my/logo.png" (or unchanged at the root). */
export function appPath(path: string): string {
  return BASE_PATH + path.replace(/^\/+/, "");
}

/** Absolute URL of an app page, e.g. for an auth redirect: https://…/my/auth-callback */
export function appUrl(path: string): string {
  return new URL(appPath(path), window.location.origin).toString();
}
